export const Services: React.FC<any> = (_props) => {
    return <article> This is the servcies page.</article>;
  };
  